export default "__VITE_ASSET__4cf49ce5__"